"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDiscounts = exports.regex = void 0;
exports.regex = {
    zipCode: '^(\\d{5}([\\-]\\d{4})?)$',
    cookie: '(^|;) ?name=([^;]*)(;|$)'
};
/**
 * Sort discounts by amount
 * @param {Object} cart Current cart object
 * @returns {Array<{amount: number}>
 */
const sortDiscounts = (cart) => {
    if (cart && cart.priceDiscounts) {
        return cart.priceDiscounts.sort((a, b) => Math.abs(b.amount) - Math.abs(a.amount));
    }
    return [];
};
exports.sortDiscounts = sortDiscounts;
//# sourceMappingURL=index.js.map